// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/diagnose.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/diagnose.tsx");
  import.meta.hot.lastModified = "1730642741826.035";
}
// REMIX HMR END

import React from "react";
import StepCard from "~/components/stepCard/stepCard";
import { motion } from "framer-motion";
import { fadeIn } from "~/lib/variants";
export const meta = () => {
  return [{
    title: "عیب یابی XRayBOX"
  }, {
    name: "description",
    content: `به دلایل مختلفی ممکن است ارتباط دستگاه روتر شما با سرورها قطع شده و
      قابل استفاده نباشد. در زیر به تعدادی از این موارد اشاره گردیده است:
      `
  }, {
    name: "robots",
    content: "index, follow"
  }, {
    name: "og:image",
    content: "/assets/img/xraybox.png"
  }];
};
const DiagnoseIndex = () => {
  return <div className="h-full bg-no-repeat bg-cover bg-center">
      <section className="w-full pt-20 px-4 mx-auto md:container" id="diagnose">
        <motion.h1 variants={fadeIn("down", 0.2, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className=" px-1 py-3 text-3xl md:text-4xl font-bold tracking-tight transition-colors">
          عیب یابی
        </motion.h1>
        <motion.p variants={fadeIn("right", 0.4, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-3 text-base md:text-lg">
          به دلایل مختلفی ممکن است ارتباط دستگاه روتر شما با سرورها قطع شده و
          قابل استفاده نباشد
        </motion.p>
        <ol className="list-decimal ms-8">
          <motion.li variants={fadeIn("right", 0.5, 1.3)} viewport={{
          once: true
        }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-1 text-base">
            قطع شدن اینترنت دیتاسنتر و یا زیر ساخت کشور
          </motion.li>
          <motion.li variants={fadeIn("right", 0.6, 1.3)} viewport={{
          once: true
        }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-1 text-base">
            قطع شدن اینترنت مودم به دلیل تمام شدن حجم و یا زمان اشتراک آن
          </motion.li>
          <motion.li variants={fadeIn("right", 0.7, 1.3)} viewport={{
          once: true
        }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-1 text-base">
            عدم داشتن کیفیت مناسب اینترنت دریافتی (مشکل اکثر کاربران)
          </motion.li>
          <motion.li variants={fadeIn("right", 0.7, 1.3)} viewport={{
          once: true
        }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-1 text-base">
            خاموش شدن مودم
          </motion.li>
          <motion.li variants={fadeIn("right", 0.7, 1.3)} viewport={{
          once: true
        }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-1 text-base">
            قطعی کابل رابط بین مودم و روتر (یکی از موارد رایج در بین کاربران)
          </motion.li>
          <motion.li variants={fadeIn("right", 0.7, 1.3)} viewport={{
          once: true
        }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-1 text-base">
            درآمدن کابل شبکه از پورت روتر و یا مودم
          </motion.li>
        </ol>
        <motion.h2 variants={fadeIn("down", 0.8, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className=" px-1 py-3 text-2xl md:text-3xl font-bold tracking-tight transition-colors">
          در صورت قطع شدن ارتباط روتر چه کنیم؟
        </motion.h2>
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-8 px-8 md:px-12 lg:px-16 pt-12">
          <StepCard step="1">
            ابتدا{" "}
            <strong className="text-pink-600">روتر را خاموش و روشن</strong>{" "}
            نمایید. <br /> در اکثر مواقع صرفا با انجام اینکار ارتباط روتر با
            سرورها برقرار میگردد.
          </StepCard>
          <StepCard step="2">
            از <strong className="text-pink-600">وصل بودن اینترنت مودم</strong>{" "}
            اطمینان حاصل فرمایید. برای اینکار کافیست به وای فای مودم وصل شده و
            یه سایت ایرانی مثل فیلیمو و دیجی کالا را باز کنید.
          </StepCard>
          <StepCard step="3">
            <strong className="text-pink-600">کابل شبکه و محل اتصالات</strong>{" "}
            بین مودم و روتر را چک کرده. <br /> درصورت داشتن کابل اضافی حتی
            الامکان آنرا تعویض نمایید. <br />
            حال مودم و روتر را به ترتیب خاموش و روشن کرده و مجدد ارتباط خود را
            چک کنید.
          </StepCard>
          <StepCard step="4">
            در انتها اگر مطمئن شدید که روتر شما اینترنت دارد اما به سرور وصل
            نمیشود{" "}
            <strong className="text-pink-600">به پشتیبانی پیام دهید</strong>.
          </StepCard>
        </div>
        <motion.blockquote variants={fadeIn("right", 0.3, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className="mt-6 border-r-2 flex w-fit bg-blue-700 font-semibold text-lg lg:text-xl pr-6 italic">
          در صورت رسیدن اینترنت با کیفیت مطلوب بدون هیچ قید و شرطی روتر به سرور
          وصل شده و کار مینماید.
        </motion.blockquote>
        <motion.blockquote variants={fadeIn("right", 0.5, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className="mt-6 border-r-2 flex w-fit bg-blue-700 font-semibold text-lg lg:text-xl pr-6 italic">
          کیفیت اینترنت ربطی به سرعت آن ندارد، منظور از اینترنت با کیفیت مطلوب
          با ثبات بودن و عدم قطعی آن در حین کار میباشد.
        </motion.blockquote>
        <motion.h2 variants={fadeIn("down", 0.3, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className=" px-1 pb-3 pt-12 text-2xl md:text-3xl font-bold tracking-tight transition-colors">
          کیفیت اینترنت و تاثیر آن در کارکرد روتر
        </motion.h2>
        <motion.p variants={fadeIn("right", 0.4, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-3 text-base md:text-lg">
          همانطور که در بالا ذکر شد مهمترین عامل قطع شدن روترها کیفیت اینترنت
          دریافتی آنها میباشد.
          <br />
          کیفیت اینترنت را به سه دسته تقسیم میکنیم:
        </motion.p>
        <ol className="list-decimal ms-8">
          <motion.li variants={fadeIn("right", 0.5, 1.3)} viewport={{
          once: true
        }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-1 text-base">
            خوب
          </motion.li>
          <motion.li variants={fadeIn("right", 0.6, 1.3)} viewport={{
          once: true
        }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-1 text-base">
            متوسط
          </motion.li>
          <motion.li variants={fadeIn("right", 0.7, 1.3)} viewport={{
          once: true
        }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-1 text-base">
            بد
          </motion.li>
        </ol>

        <motion.p variants={fadeIn("right", 0.4, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-3 text-base md:text-lg">
          در تصاویر زیر شما میتوانید فرق این سه نوع اینترنت و سرویس دهی آنها را
          به کاربر ببینید:
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mx-auto">
          <img src="/assets/img/diagnose/test1.jpg" alt="تست اینترنت خوب" className="w-full h-56 object-cover" />
          <img src="/assets/img/diagnose/test2.jpg" alt="تست اینترنت متوسط" className="w-full h-56 object-cover" />
          <img src="/assets/img/diagnose/test3.jpg" alt="تست اینترنت بد" className="w-full h-56 object-cover" />
        </div>
        <motion.blockquote variants={fadeIn("right", 0.5, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className="mt-6 border-r-2 flex w-fit bg-blue-700 font-semibold text-lg lg:text-xl pr-6 italic">
          فهمیدن کیفیت اینترنت شما صرفا از طریق کامپیوتر امکان پذیر بوده و از
          طریق کارکردن و یا گرفتن تست سرعت به هیچ وجهی این مساله قابل درک
          نمیباشد.
        </motion.blockquote>
        <motion.p variants={fadeIn("right", 0.4, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-3 text-base md:text-lg">
          برای انجام اینکار میبایست در محیط ویندوز به قسمت RUN رفته و واژه cmd
          را تایپ نمایید. بعد از اجرای برنامه دستور زیر را تایپ کرده و اینتر
          کنید.
        </motion.p>
        <code className="bg-slate-800 border-l border-red-600 py-3 px-2 my-4">
          ping 4.2.2.4 -t
        </code>
        <motion.p variants={fadeIn("right", 0.5, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-3 text-base md:text-lg">
          این دستور بصورت پیوسته با گرفتن پینگ ارتباط شما را با اینترنت چک کرده
          و به محض مشاهده قطعی در اینترنت پیغام Request timed out میدهد و پس از
          وصل شدن مجدد پینگ دستگاه را اعلام مینماید. <br /> با این تست صرفا
          کیفیت اینترنت در آن لحظه مشخص میگردد. چرا که با توجه به شرایط کنونی
          کشور اینترنتهای موجود ثباتی نداشته و سرعت و کیفیت آنها مرتب در حال
          تغییر میباشد.
        </motion.p>
        <motion.p variants={fadeIn("right", 0.7, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-3 text-base md:text-lg">
          اگر در تصاویر بالا دقت کنید خواهید دید در اینترنت با کیفیت مطلوب
          (تصویر شماره 1) هیچگونه قطعی در حین کار وجود نداشته و کاملا با یک
          کیفیت مناسب و ایده آل اطلاعات دریافت میگردد.در تصویر شماره 2 که نشان
          دهنده ی کیفیت متوسط میباشد گاها در حین کار ارتباط قطع شده و مجدد
          برقرار میگردد. به قطع و وصل شدن لحظه ای و از دست رفتن بسته های
          اینترنتی که در حال جابجایی میباشند پاکت لاس (Packet Loss) گفته میشود.
          در تصویر شماره 3 که کاملا نشان دهنده یک اینترنت بی کیفیت میباشد میزان
          پاکت لاس بسیار زیاد بوده و مرتب اینترنت شما در حال قطع و وصل شدن
          میباشد.
        </motion.p>

        <motion.h2 variants={fadeIn("down", 0.3, 1.3)} viewport={{
        once: true
      }} initial="hidden" whileInView="show" exit="hidden" className=" px-1 py-3 text-2xl md:text-3xl font-bold tracking-tight transition-colors">
          نحوه عملکرد روتر در قبال هر یک از کیفیت های مطرح شده در بالا:
        </motion.h2>
        <ol className="list-decimal ms-8">
          <motion.li variants={fadeIn("right", 0.5, 1.3)} viewport={{
          once: true
        }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-1 text-base">
            <strong className="text-primary font-semibold">
              اینترنت خوب:{" "}
            </strong>
            بدون هیچ مشکلی به کار خود ادامه میدهد و بر اساس سرعت اینترنت دریافتی
            به شما سرویس ارائه میکند.
          </motion.li>
          <motion.li variants={fadeIn("right", 0.5, 1.3)} viewport={{
          once: true
        }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-1 text-base">
            <strong className="text-primary font-semibold">
              اینترنت متوسط:{" "}
            </strong>
            معمولا در این نوع اینترنت ، روتر با وجود پاکت لاس های موردی و از بین
            رفتن بخش کوچکی از اطلاعات در حین انتقال آنها ، تا حد امکان آنرا
            اصلاح کرده و به کار خود ادامه میدهد.
          </motion.li>
          <motion.li variants={fadeIn("right", 0.5, 1.3)} viewport={{
          once: true
        }} initial="hidden" whileInView="show" exit="hidden" className="px-1 py-1 text-base">
            <strong className="text-primary font-semibold">اینترنت بد: </strong>
            بزرگترین مشکلی که در حال حاضر برای کاربران مجموعه وجود دارد دقیقا
            همین مورد میباشد. <br />
            <br />
            <strong className="font-bold text-lg ">
              متاسفانه خیلی از کاربران وقتی اقدام به خرید این روتر مینمایند
              اینطور فکر میکنند که این دستگاه منبعد تمامی مشکلات آنها را در
              زمینه اینترنتی حل کرده و میبایست در هر لحظه و هر مکانی بدون
              کوچکترین مشکلی به آنها سرویس دهد در صورتیکه این روتر بر اساس
              برنامه ریزی و تنظیماتی که در آن انجام شده صرفا با استفاده از بستر
              اینترنت خود کاربر، اطلاعات درخواستی را استخراج و به شما نمایش
              میدهد. اگر این بستر دچار مشکل باشد به هیچ وجهی این انتقال داده ها
              امکان پذیر نمیباشد و باعث قطع ارتباط روتر با سرورها میگردد.
            </strong>
          </motion.li>
        </ol>
        
      </section>
    </div>;
};
_c = DiagnoseIndex;
export default DiagnoseIndex;
var _c;
$RefreshReg$(_c, "DiagnoseIndex");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;